import React, {useEffect, useState} from "react";

interface PaginationProps {
    totalCount: number;
    currentPage: number;
    onChangeCallback: (i: number) => any;
    limit?: number;
    disabled?: boolean;
    onDisabledCallback?: () => void;
}

/**
 * URL query string 사용하지 않고 내부 state를 사용하는 Pagination
 * 서브 탭 등에 있는 리스트의 Pagination에만 사용
 */
export default function PaginationSub({
                                          totalCount,
                                          currentPage,
                                          onChangeCallback,
                                          limit = 10,
                                          disabled,
                                          onDisabledCallback
                                      }: PaginationProps) {
    const [condition, setCondition] = useState<number>(1);

    const totalPage = totalCount !== 0 ? Math.ceil(totalCount / limit) : 1;

    useEffect(() => {
        setCondition(currentPage);
    }, [currentPage]);

    const buildPage = (pageNo: number) => {
        const pageElement = [];

        const pageDisplayCount = 9;
        const half = Math.floor(pageDisplayCount / 2);

        let startPage = pageNo - half;
        let endPage = pageNo + half;

        // 1보다 작으면 앞쪽 보정
        if (startPage < 1) {
            endPage += (1 - startPage);
            startPage = 1;
        }

        // 마지막 페이지보다 크면 뒤쪽 보정
        if (endPage > totalPage) {
            startPage -= (endPage - totalPage);
            endPage = totalPage;
        }

        // 다시 1보다 작을 수 있으므로 보정
        if (startPage < 1) startPage = 1;

        for (let i = startPage; i <= endPage; i++) {
            if (i === pageNo) {
                pageElement.push(<li key={i} className="active">{i}</li>);
            } else {
                pageElement.push(
                    <li key={i} className="" onClick={() => btnCallback(i)}>
                        {i}
                    </li>
                );
            }
        }

        return pageElement;
    };

    const btnCallback = (number: number) => {
        if (!disabled) {
            setCondition(number);
            onChangeCallback(number);
        } else {
            onDisabledCallback && onDisabledCallback()
        }
    };

    return (
        <div className="pagination-container">
            <ul>
                <li className="pg_nav" onClick={() => condition > 1 && btnCallback(1)}>
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                        alt="First Page"
                    />
                </li>
                <li className="pg_nav" onClick={() => condition > 1 && btnCallback(condition - 1)}>
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                        alt="Previous Page"
                    />
                </li>
                {buildPage(currentPage)}
                <li className="pg_nav" onClick={() => condition < totalPage && btnCallback(condition + 1)}>
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                        alt="Next Page"
                    />
                </li>
                <li className="pg_nav" onClick={() => condition < totalPage && btnCallback(totalPage)}>
                    <img
                        src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                        alt="Last Page"
                    />
                </li>
            </ul>
        </div>
    );
}